export default __webpack_public_path__ + "3b5f54118e26f66565e82f20810e1d6a.jpg";